var map = {
	"./0/Kambi/Rewards.resource.js": [
		90075,
		51002
	],
	"./0/Poker/Rewards.resource.js": [
		15346,
		76197
	],
	"./0/Spectate/Rewards.resource.js": [
		98930,
		39619
	],
	"./1/Kambi/Rewards.resource.js": [
		34478,
		76591
	],
	"./1/Poker/Rewards.resource.js": [
		4339,
		4534
	],
	"./1/Spectate/Rewards.resource.js": [
		11505,
		37454
	],
	"./31/Kambi/Rewards.resource.js": [
		49267,
		24714
	],
	"./31/Poker/Rewards.resource.js": [
		43418,
		19523
	],
	"./31/Spectate/Rewards.resource.js": [
		16106,
		67593
	],
	"./58/Spectate/Rewards.resource.js": [
		93487,
		43410
	],
	"./75/Kambi/Rewards.resource.js": [
		85547,
		2546
	],
	"./75/Spectate/Rewards.resource.js": [
		48514,
		69625
	],
	"./76/Kambi/Rewards.resource.js": [
		33852,
		66105
	],
	"./76/Spectate/Rewards.resource.js": [
		94731,
		12978
	],
	"./8/Poker/Rewards.resource.js": [
		80666,
		15021
	],
	"./8/Spectate/Rewards.resource.js": [
		50858,
		54603
	],
	"./81/Kambi/Rewards.resource.js": [
		42214,
		23359
	],
	"./81/Spectate/Rewards.resource.js": [
		20233,
		6384
	],
	"./84/Kambi/Rewards.resource.js": [
		99831,
		90038
	],
	"./84/Spectate/Rewards.resource.js": [
		94670,
		15889
	],
	"./86/Spectate/Rewards.resource.js": [
		95640,
		59231
	],
	"./87/Spectate/Rewards.resource.js": [
		88231,
		77962
	],
	"./88/Spectate/Rewards.resource.js": [
		82066,
		79381
	],
	"./89/Spectate/Rewards.resource.js": [
		59473,
		54056
	],
	"./90/Spectate/Rewards.resource.js": [
		11011,
		45254
	],
	"./91/Spectate/Rewards.resource.js": [
		70804,
		73019
	],
	"./92/Spectate/Rewards.resource.js": [
		76825,
		69376
	],
	"./94/Spectate/Rewards.resource.js": [
		61719,
		89594
	],
	"./95/Spectate/Rewards.resource.js": [
		45448,
		97231
	],
	"./96/Poker/Rewards.resource.js": [
		50263,
		42284
	],
	"./96/Spectate/Rewards.resource.js": [
		58637,
		68548
	],
	"./default/Kambi/Rewards.resource.js": [
		37048,
		39779
	],
	"./default/Spectate/Rewards.resource.js": [
		27319,
		39606
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 57115;
module.exports = webpackAsyncContext;